module.exports = __webpack_public_path__ + "img/hero@2x.35594772.webp";